import { Controller, SubmitHandler, useFormContext } from 'react-hook-form';
import {
  PrimaryButton, PrimaryTextField, ErrorMessage, SecondaryLink,
} from 'components';
import { ISignInForm } from 'base/auth/interface';

interface Props {
  onSubmit: SubmitHandler<any>;
}

const SignInFormView = (props: Props) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useFormContext<ISignInForm>();
  const { onSubmit } = props;
  return (
    <form data-testid="sign-in-form-view" onSubmit={handleSubmit(onSubmit)} style={{ textAlign: 'left' }}>
      <div className="form-item">
        <Controller
          control={control}
          name="name"
          render={({ field }) => (
            <PrimaryTextField {...field} label="Email address" inputProps={{ 'data-testid': 'email' }} />
          )}
        />
        <ErrorMessage>{errors?.name?.message}</ErrorMessage>
      </div>
      <div className="form-item">
        <Controller
          control={control}
          name="password"
          render={({ field }) => (
            <PrimaryTextField {...field} label="Password" isPassword inputProps={{ 'data-testid': 'password' }} />
          )}
        />
        <ErrorMessage>{errors?.password?.message}</ErrorMessage>
      </div>
      <div className="form-item text-center">
        <SecondaryLink to="/forgot-password">Forgot your password?</SecondaryLink>
      </div>
      <div className="form-item">
        <PrimaryButton size="large" fullWidth type="submit">
          Sign in
        </PrimaryButton>
      </div>
    </form>
  );
};

export default SignInFormView;
